module.exports = __webpack_public_path__ + "img/8.f01446d7.jpg";